'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var getRaceInfoKey = function getRaceInfoKey(_ref) {
    var bookmaker = _ref.bookmaker,
        raceTime = _ref.raceTime,
        raceDate = _ref.raceDate,
        courseName = _ref.courseName;

    if (!(raceTime && raceDate && courseName && bookmaker)) {
        // eslint-disable-next-line no-console
        console.error('no required info data in: getRaceInfoKey');
    }
    return (raceDate + '/' + raceTime + '/' + courseName + '/' + bookmaker).toUpperCase();
};

var PricesStateStore = function () {
    function PricesStateStore() {
        _classCallCheck(this, PricesStateStore);

        this.showDecimalPrices = false;
        this.raceInfo = {};
        this.currentBookmakerName = null;
    }

    _createClass(PricesStateStore, [{
        key: 'setPriceViewType',
        value: function setPriceViewType(_ref2) {
            var showDecimal = _ref2.showDecimal;

            this.showDecimalPrices = showDecimal;
        }
    }, {
        key: 'isDecimalPrice',
        value: function isDecimalPrice() {
            return this.showDecimalPrices;
        }
    }, {
        key: 'setCurrentBookmaker',
        value: function setCurrentBookmaker(bookmakerName) {
            this.currentBookmakerName = bookmakerName;
        }
    }, {
        key: 'getCurrentBookmaker',
        value: function getCurrentBookmaker() {
            return this.currentBookmakerName;
        }
    }, {
        key: 'updateRaceInfo',
        value: function updateRaceInfo(_ref3) {
            var bookmaker = _ref3.bookmaker,
                raceTime = _ref3.raceTime,
                raceDate = _ref3.raceDate,
                courseName = _ref3.courseName,
                suspendState = _ref3.suspendState,
                winOdds = _ref3.winOdds,
                placeWinner = _ref3.placeWinner,
                isBog = _ref3.isBog;

            var statusKey = getRaceInfoKey({ bookmaker: bookmaker, raceTime: raceTime, raceDate: raceDate, courseName: courseName });

            this.raceInfo[statusKey] = { suspendState: suspendState, winOdds: winOdds, placeWinner: placeWinner, isBog: isBog };
        }
    }, {
        key: 'getRaceInfo',
        value: function getRaceInfo(_ref4) {
            var bookmaker = _ref4.bookmaker,
                raceTime = _ref4.raceTime,
                raceDate = _ref4.raceDate,
                courseName = _ref4.courseName;

            return this.raceInfo[getRaceInfoKey({ bookmaker: bookmaker, raceTime: raceTime, raceDate: raceDate, courseName: courseName })];
        }
    }]);

    return PricesStateStore;
}();
// TODO: export constructor and instantiate it in place of usage (JIRA: PC-4559)
/* eslint-disable import/prefer-default-export */


var pricesStateStore = exports.pricesStateStore = new PricesStateStore();


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/stores/PricesStateStore.js
// module id = 174
// module chunks = 1